/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { vappContainer } from '@/application';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

export interface ICreateCarricomAppMethods extends IPluginMethodMap {
  createCarricomApp(args: any): Promise<any>;
}

export interface CreateCarricomAppProps {}

export class CreateCarricomAppService implements IAgentPlugin {
  readonly methods: ICreateCarricomAppMethods;

  constructor() {
    this.methods = {
      createCarricomApp: this.createCarricomApp.bind(this),
    };
  }

  async createCarricomApp(args: CreateCarricomAppProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    console.log(`service input data`, args);
    try {
      if (client) {
        const res = await client.mutate({
          // mutation: UPDATE_MY_ORGANIZATION,
          variables: {
            input: {
              ...args,
            },
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
